import { render, staticRenderFns } from "./ques2_1.vue?vue&type=template&id=7774f4a7"
import script from "./ques2_1.vue?vue&type=script&lang=js"
export * from "./ques2_1.vue?vue&type=script&lang=js"
import style0 from "./ques2_1.vue?vue&type=style&index=0&id=7774f4a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports